import React from "react";
import styled from "styled-components";

import * as u from "../../utils";
import * as gtag from "../../utils/gtag";
import * as UserContext from "../../components/UserContext";
import CollectionCard from "../../components/AcademyCollectionCard";
import Button from "../../components/Button";
import RxSubNavAcademy from "../../components/ui/navigation/RxSubNavAcademy";

export default function Academy(props) {
  const userInfo = React.useContext(UserContext.Context);
  const { hasLoaded } = userInfo;
  const [showMoreCollections, setShowMoreCollections] = React.useState(false);

  const shownCollections = showMoreCollections
    ? props.collections
    : props.collections.slice(0, 6);

  return (
    hasLoaded && (
      <>
        <RxSubNavAcademy />
        <S.Container>
          <S.Lessons data-cy="course-collections">
            {shownCollections.map(getCollection)}
          </S.Lessons>
          <S.ShowMoreButton
            onClick={goShowMoreCollections}
            hide={showMoreCollections}
          />
        </S.Container>
      </>
    )
  );

  function getCollection(collection) {
    return (
      <CollectionCard
        key={collection.courseName}
        isMember
        userInfo={userInfo}
        {...collection}
      />
    );
  }

  function goShowMoreCollections() {
    gtag.event({
      name: gtag.GA_EVENT.ACADEMY_SHOW_MORE,
      category: "Academy",
      label: "Show more collections",
      value: "collections",
    });

    return setShowMoreCollections(true);
  }
}

export async function getStaticProps({ locale }) {
  const axios = require("axios");
  const { CONTENTFUL_GENERAL } = require("../../config");

  const collectionData = (
    await axios.post(CONTENTFUL_GENERAL, getCollectionsQuery())
  ).data.data.courseCollection.items;
  const goalsAndCollections = (
    await axios.post(CONTENTFUL_GENERAL, getGoalsQuery())
  ).data.data;
  const goals = goalsAndCollections.goalCollection.items;
  const collectionsMissingGoals = collectionData.filter(byLocale);
  const collections = collectionsMissingGoals.map((coll) => {
    const thisCollection = goalsAndCollections.courseCollection.items.find(
      (c) => coll.courseName === c.courseName
    );
    const goals = thisCollection.goalTagsCollection.items.map((g) => g.name);
    return { ...coll, goals };
  });

  return { props: { collections, goals }, revalidate: 3600 };

  function byLocale(item) {
    if (!item.locale) return true;
    return item.locale.includes(locale);
  }

  function getCollectionsQuery() {
    return {
      query: `{
        courseCollection {
          items {
            courseName
            courseCardImage { title url }
            urlSlug
            region
            coursesCollection { total }
          }
        }
      }`,
    };
  }

  function getGoalsQuery() {
    return {
      query: `{
        goalCollection {
          items { name }
        }

        courseCollection {
          items {
            courseName
            goalTagsCollection { items { name } }
          }
        }
      }`,
    };
  }
}

const S = {};

S.Container = styled.div`
  max-width: 1440px;
  margin: auto;
  padding: 20px 16px;

  @media ${u.device.tablet} {
    padding: 20px;
  }

  @media ${u.device.desktop} {
    padding: 40px;
  }
`;

S.ShowMoreButton = styled(Button).attrs(() => ({
  text: "Show more",
  isSecondary: true,
}))`
  margin: 40px auto 0;
  display: ${(props) => (props.hide ? "none" : "flex")};
`;

S.Lessons = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  @media ${u.device.tablet} {
    grid-template-columns: 1fr 1fr;
    grid-gap: 40px;
  }
  @media ${u.device.desktop} {
    grid-template-columns: 1fr 1fr 1fr;
    margin: 40px 0;
  }
`;
